import { useQuery } from "@tanstack/react-query";

import { checkPecos } from "@/api/doctors";

export function useCheckPecos(npi: string, enabled = true) {
  return useQuery({
    queryKey: ["doctor", "checkPecosQuery", npi],
    queryFn: () => checkPecos(npi),
    enabled,
  });
}
